import { useState, useEffect } from "react";
import { getDoc, doc } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { COLLECTIONS } from "@/constants/firestoreCollections";
import type { UserData } from "@/types/user";
import { UserRole } from "@/types/user";

export function useCurrentUserRole(uid: string | undefined) {
  const [userData, setUserData] = useState<UserData | null>(null);
  const [loading, setLoading] = useState(!!uid);

  useEffect(() => {
    if (!uid) {
      setUserData(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    const ref = doc(db, COLLECTIONS.USERS, uid);
    getDoc(ref).then((snap) => {
      if (cancelled) return;
      if (snap.exists()) {
        const data = snap.data() as Record<string, unknown>;
        setUserData({
          id: snap.id,
          uid: snap.id,
          email: data.email as string | null,
          displayName: (data.displayName ?? data.name) as string | null,
          firstName: (data.firstName ?? data.name) as string,
          lastName: (data.lastName as string) ?? "",
          role: (data.role as UserRole) ?? UserRole.CLIENT,
          ...data,
        });
      } else {
        setUserData(null);
      }
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [uid]);

  const isAdmin = userData?.role === UserRole.ADMIN || userData?.role === "admin";
  return { userData, loading, isAdmin };
}
